import { withInstall } from '@code-monkey-ui/utils'

import Text from './src/text.vue'

export const ElText = withInstall(Text)
export default ElText

export * from './src/text'
